import { Map } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { CrewMapper } from "features/planner/planner.mappers";

const initialState = Map({});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_CREWS: {
      if (error) return state;

      return Map(
        payload.map(Crew => [Crew.crewId.toString(), CrewMapper.from(Crew)]),
      );
    }

    case ACTIONS.GET_CREW:
    case ACTIONS.UPDATE_CREW:
    case ACTIONS.CREATE_CREW: {
      if (error) return state;

      return state.set(payload.crewId.toString(), CrewMapper.from(payload));
    }

    case ACTIONS.DELETE_CREW: {
      if (error) return state;

      return state.delete(action.crewId.toString());
    }

    default:
      return state;
  }
};
